export default "__VITE_ASSET__a0cc1f73__"